import { useOwners } from "PFApp/activities/show/parts/hooks/use_owners";
import { ActivityProfilesAvatarStack } from "PFApp/components/activity_profiles_avatar_stack";
import { Typography } from "PFComponents/typography";
import { MatchedActivity } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import { Section } from "../../components";
import css from "./owners_section.module.scss";

type OwnersSectionProps = {
  role: MatchedActivity["activity"];
};

export const OwnersSection = ({ role }: OwnersSectionProps) => {
  const { t } = useTranslation("marketplace", { keyPrefix: "workOpportunities.roleDetails.owners" });
  const { canView, owners, principalOwner } = useOwners(role);

  return (
    <Section>
      <div className={css.mainContainer}>
        {canView && (
          <div className={css.ownersContainer}>
            <Typography variant="bodyBold" noMargin>
              {t("owners")}
            </Typography>
            <ActivityProfilesAvatarStack displayChatIcon={false} profiles={owners} />
          </div>
        )}
        {principalOwner && (
          <div className={css.ownersContainer}>
            <Typography variant="bodyBold" noMargin>
              {t("principal")}
            </Typography>
            <ActivityProfilesAvatarStack displayChatIcon={false} profiles={[principalOwner]} />
          </div>
        )}
      </div>
    </Section>
  );
};
